import { call, put, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/products';
import api from '~/services/api';

function* loadProductsByCode({ partner, code }) {
  try {
    const { data } = yield call(api.get, `/v1/partners/${partner}/products`, {
      params: { code }
    });

    const items = (data.entries || []).map(i => ({ text: i.code, value: i }));

    yield put(actions.loadProductsByCodeSuccess(items));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadProductsByName({ partner, name }) {
  try {
    const { data } = yield call(api.get, `/v1/partners/${partner}/products`, {
      params: { name }
    });

    const items = (data.entries || []).map(i => ({ text: i.name, value: i }));

    yield put(actions.loadProductsByNameSuccess(items));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_PRODUCTS_BY_CODE, loadProductsByCode),
  takeLatest(Types.LOAD_PRODUCTS_BY_NAME, loadProductsByName)
];

export default sagas;
